import * as monacoEditor from 'monaco-editor';

import { SDL_EDITOR_ID } from './sdlEditorId';

export function uriToServiceName(uri: monacoEditor.Uri) {
  return uri.path.slice(`/${SDL_EDITOR_ID}/`.length);
}
